import StandCollectionsSync from "../../../utils/localDB/standcollections";
import StandCollectionsApi from "../standcollections";

class StandCollectionsManager {

    async getList(params) {
        if (params.isOffline) {
            return await new StandCollectionsSync().getList(params)
        }
        try {
            const result = await StandCollectionsApi.getList(params)
            window.postMessage('online')
            return result
        } catch (error) {
            const result = await new StandCollectionsSync().getList(params)
            window.postMessage('offline')
            return result
        }
    }
}

export default new StandCollectionsManager()
